/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=5acc6640"
const script = {}

import "./index.vue?vue&type=style&index=0&id=5acc6640&lang=less"

import exportComponent from "/Users/sujian/Desktop/lihu/吕楠中医挂号平台/voice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__